import React from 'react'
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

function CancelationandRefund() {
  return (
    <div className="terms-bg">
    <Header />
    <div className="terms-container container ">
      <div className="terms-header container">
        <h1>Cancelation and Refund policy</h1>
      </div>

      <div className="terms-content">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Qflyers, a digital menu card platform designed to help
          creators seamlessly connect their audiences with the latest and most
          relevant content. Our mission is to make this process as simple and
          efficient as possible, reflecting our core value of deliberate
          simplicity.
        </p>
        <p>
          Ensure a smooth and transparent experience, we have outlined our
          Terms and Conditions in a clear and accessible manner. These Terms,
          along with our associated policies, govern your use of Qflyers,
          which includes our website (https://qflyers.com/), mobile
          applications, and all related features, tools, and software
          (collectively referred to as the “Platform” or “Qflyers”).
        </p>
        <p>
          When we mention "we," "our," or "us", we are referring to Qflyers,
          Falcon Square, and our affiliated group of companies. By accessing
          or using Qflyers, you acknowledge that you have read, understood,
          and agreed to comply with these Terms and Conditions (“Terms”),
          along with the additional policies available on our Platform.
        </p>
        <p>
          We encourage you to take the time to carefully review these Terms.
          If you have any questions, feel free to reach out to us for
          clarification. However, if you do not agree with these Terms, we
          kindly ask that you refrain from using Qflyers.
        </p>

        <h2>2. Your Account</h2>
        <p>
          To use Qflyers, you must first create an account, and by doing so,
          you confirm that you are at least 18 years old. If you are setting
          up an account on behalf of another person, you must have their
          explicit permission to do so. As a Qflyers user, you are solely
          responsible for maintaining your account and ensuring that it is
          used in a lawful and appropriate manner. Your account should reflect
          honest and accurate information about you, and if any of your
          details change, you are required to update them to keep your account
          information current.
        </p>
        <p>
          By creating an account, you acknowledge that you have read,
          understood, and agreed to these Terms. You also confirm that you
          have the legal capacity to enter into this agreement with Qflyers.
          If you are using the platform on behalf of a company, business, or
          another individual, you must ensure that you have the proper
          authorization to accept these Terms on their behalf. In such cases,
          your responsibility extends to any actions taken within the account,
          and you must act in accordance with these Terms to protect both your
          interests and those of the entity you represent
        </p>
        <p>
          Your account security is essential, and it is your duty to safeguard
          your login credentials. You should not share your username or
          password with anyone else, as you are accountable for any activities
          performed through your account. If you suspect that your account has
          been compromised, such as unauthorized access or suspicious
          activity, you must notify Qflyers immediately so that appropriate
          action can be taken to protect your information.
        </p>
        <p>
          Additionally, your account is meant for personal use, and you are
          not allowed to transfer, assign, or sell it to another individual.
          Any misuse of your account that may cause harm to Qflyers, damage
          our reputation, or violate the rights of others is strictly
          prohibited. You must also ensure that your actions comply with all
          applicable laws and regulations while using the platform. Qflyers
          reserves the right to take necessary measures, including suspending
          or terminating accounts, in cases where these Terms are violated. By
          following these guidelines, you help maintain a safe and trustworthy
          environment for all users.
        </p>
        <h2>3. Managing Your Plan</h2>
        <p>
          Managing your plan on Qflyers is designed to be flexible and
          straightforward, offering both free and paid subscription options.
          When you sign up for Qflyers, your chosen plan will commence as soon
          as you accept these Terms. Your subscription will continue
          indefinitely until you decide to cancel it. You are free to cancel
          your plan at any time, giving you full control over your
          subscription. If you choose to cancel a paid plan, your subscription
          will typically remain active until the end of your current billing
          cycle. Once the billing cycle ends, your account will automatically
          switch to the free plan without any further charges.
        </p>
        <p>
          To cancel your subscription, you can access the Billing Page through
          the Qflyers platform at https://qflyers.com/admin/billing. Payments
          made for Qflyers subscriptions are generally non-refundable, as
          permitted by applicable law. However, we understand that your
          requirements may change unexpectedly. If you cancel a paid plan
          within 72 hours of purchase, you may request an exception by
          reaching out to our support team at support@qflyers.com. While we
          will make every effort to accommodate your request, refunds outside
          this window cannot be guaranteed.
        </p>
        <p>
          If you purchased your subscription through the Apple App Store or
          Google Play Store, the cancellation process must be handled directly
          through those platforms. Qflyers is unable to issue refunds for
          purchases made through third-party providers. You can request
          refunds from Apple via their Apple Support webpage or from Google by
          following their refund request instructions. We recommend reviewing
          their individual policies to understand your eligibility for
          refunds.
        </p>
        <p>
          Should you decide to permanently delete your account after canceling
          your subscription, you can do so through the ‘My Account’ page on
          the platform. It’s important to note that once your account is
          deleted, it cannot be reactivated. All content, data, and
          information associated with your profile will be permanently removed
          without the possibility of recovery. We encourage you to carefully
          consider this decision and download any important information before
          proceeding. By offering these flexible plan management options,
          Qflyers aims to provide users with greater control over their
          subscription journey
        </p>
        <h2>4.Your Content </h2>
        <div class="community-standards">
          <p>
            At Qflyers, we celebrate the diverse range of content that our
            users share, from engaging text and graphics to videos, links, and
            products. However, ensuring a safe and welcoming environment for
            all visitors is a top priority. To maintain this, we have
            Community Standards that outline what type of content is permitted
            on the platform. It is essential that you adhere to these
            guidelines, as failing to do so may result in account suspension
            or permanent removal from Qflyers.
          </p>

          <p>
            When we refer to "your content," we mean any material you upload
            or display on Qflyers, including text, images, videos, links, and
            other digital assets. As the content creator, you bear full
            responsibility for ensuring that your content complies with our
            guidelines. By posting on Qflyers, you confirm that your content
            is either your original work or that you have obtained the
            necessary rights and permissions to share third-party materials.
            You also grant Qflyers the right to use your content in line with
            our Terms and policies.
          </p>
          <p>
            It is crucial that your content respects the rights and privacy of
            others. This means it must not infringe on intellectual property,
            trademarks, copyrights, publicity rights, or personal privacy. You
            should also ensure that the information you post is accurate,
            truthful, and not misleading in any way. Any deceptive,
            fraudulent, or unlawful content that could damage Qflyers'
            reputation is strictly prohibited.
          </p>
          <p>
            Additionally, your content must be safe for the platform and its
            users. You must not upload materials containing viruses, malware,
            or harmful code that could disrupt Qflyers or its users' systems.
            Automated data collection tools, such as scraping bots or scripts,
            are not allowed, as they undermine the integrity of the platform.
            Similarly, you are prohibited from posting unauthorized
            advertisements, spam, or promotional solicitations that have not
            been approved by Qflyers.
          </p>
          <p>
            Because Qflyers operates in multiple regions, content regulations
            may vary by country. Some materials that are legal in one
            jurisdiction may be restricted in another. To comply with local
            laws and ensure a safe digital space, we reserve the right to
            remove content, restrict access, or take other necessary actions
            when needed. By respecting these guidelines, you help foster a
            positive and secure community on Qflyers, making it a valuable
            platform for all users.
          </p>
          <h2>5. What we can do with Your Content </h2>
          <p>
            At Qflyers, we appreciate the creativity and effort you put into
            your content, and we want to showcase it in the best way possible.
            When you upload content to your Qflyers profile, you grant us a
            license to use it in various ways. This means we may display,
            distribute, modify, adapt, and create derivative works based on
            your content. Additionally, we may use your name, image, voice,
            photograph, likeness, or any other personal attributes included in
            your content on our platform and marketing materials, including
            social media, advertising, and promotional campaigns. This license
            is worldwide, royalty-free, and perpetual, allowing us to use your
            content globally, without any payment obligations, and for an
            indefinite period. By posting content on Qflyers, you confirm that
            you have obtained all necessary third-party rights and permissions
            to share it and to grant us this license.
          </p>
          <p>
            Even though you grant us these rights, you still retain full
            ownership of your content. However, keep in mind that the content
            you share on Qflyers is publicly accessible, meaning that it can
            be viewed, used, and re-shared by other users both on Qflyers and
            across the internet. Once something is posted, it may continue to
            exist online even if you later decide to remove it. For this
            reason, it’s important to carefully consider what you choose to
            share.
          </p>
          <p>
            We strongly advise against posting personal information that you
            would not want to be publicly available. Sensitive data, such as
            social security numbers, passport details, financial information,
            or any private documents, should never be shared on Qflyers. If
            such information falls into the wrong hands, it could lead to
            serious risks, including identity theft and fraud.
          </p>
          <p>
            Qflyers reserves the right to modify, remove, or restrict access
            to any content that violates these Terms or poses a potential risk
            to the platform or its users. In cases where content is deemed
            unsuitable for all audiences, we may apply a sensitive content
            warning to alert users before they engage with it. These measures
            help maintain a safe, respectful, and user-friendly environment
            for everyone on Qflyers.
          </p>
          <h2>6. Suspension or cancelation of your Account </h2>
          <p>
            At Qflyers, we strive to create a safe and compliant platform for
            all users. To maintain this, we require everyone to follow our
            Terms, Community Standards, and other linked policies. If a user
            violates these rules, we may need to suspend or cancel their
            account, restrict certain features, or adjust how they can use the
            platform. For instance, if you fail to make timely payments for a
            paid subscription, your account may be downgraded to a free plan
            with limited functionality. Similarly, if you misuse Linker
            Monetization features, we may remove your access to those specific
            tools.
          </p>
          <p>
            The action we take depends on the severity and frequency of the
            non-compliance. In some cases, minor infractions may not lead to
            immediate suspension or cancellation, and we may take less strict
            measures instead. However, repeated violations or serious breaches
            of our policies increase the likelihood of account suspension or
            termination. While we generally aim to notify users in advance
            before taking such steps, we are not legally obligated to do so.
          </p>
          <p>
            If your account is suspended, canceled, or downgraded, please note
            that no refunds will be issued for any fees you have already paid.
            Additionally, we are not responsible for any lost content or data
            resulting from these actions. This includes the removal of paid
            features that were previously accessible under a subscription
            plan. To avoid losing important content, we recommend regularly
            backing up your data and ensuring that your account remains in
            good standing.
          </p>
          <p>
            If you believe that your account has been wrongfully canceled or
            if you have concerns about these Terms or the Platform, we
            encourage you to reach out to us at support@qflyers.com. We are
            committed to resolving issues in good faith, and both parties
            agree to work together for at least one month to find a resolution
            before considering any legal action. By following these
            guidelines, we aim to maintain a fair and supportive experience
            for all Qflyers users.
          </p>
          <h2>7. Your responsibility for your visitors and customers</h2>

          <p>
            As a Qflyers user, you are fully responsible for the visitors and
            customers who engage with your profile, including those who
            purchase goods or services through the platform. These
            individuals, collectively referred to as “End Users,” interact
            with your content and transactions at your discretion. It is your
            sole responsibility to ensure that your interactions with End
            Users comply with all applicable laws and regulations. This
            includes adhering to legal requirements related to transactions,
            commerce, and payment processing when using features such as
            “Commerce” or “Payment Lock.” Qflyers does not assume any
            liability for the products or services that you advertise,
            promote, or sell through your profile.
          </p>
          <p>
            Additionally, if you utilize Qflyers’ “Support Me” feature to
            receive donations, you acknowledge that all contributions are
            voluntary and given without an expectation of receiving any goods,
            services, or benefits in return. This feature is intended
            exclusively for personal donation collection and must not be used
            to raise funds for charities, non-profit organizations, or
            external causes. Misuse of this feature for unauthorized
            fundraising or fraudulent activities may result in account
            suspension or removal.
          </p>
          <h2>8. Feedback</h2>
          <p>
            At Qflyers, we greatly appreciate your ideas and feedback on how
            to enhance our platform. Your insights help us refine our features
            and provide a better experience for all users. From time to time,
            we may introduce “beta” functionality—new or experimental features
            that are still being tested. We may invite you to try these
            features and provide feedback based on your experience.
          </p>
          <p>
            By sharing feedback with us, you agree that Qflyers is free to
            use, modify, or incorporate your suggestions in any way we see
            fit, without any obligation to compensate you. While we highly
            value user input, we are under no obligation to implement or act
            upon every piece of feedback received.
          </p>
          <p>
            Since beta features are still in the testing phase, they may not
            be as stable or reliable as other parts of the platform. You
            acknowledge that these features are subject to changes, updates,
            or removal at any time, and their performance may vary. Despite
            this, your participation in testing helps us identify potential
            improvements and make Qflyers even better for the entire
            community.
          </p>
          <h2>9. Our Platform</h2>
          <p>
            As the creators and owners of Qflyers, we grant you a limited
            right to use our platform to share content and engage with other
            users. However, it’s important to understand that while we provide
            the platform, we are not responsible for any content, products, or
            services made available through other users’ profiles. Every user
            is responsible for the content they post, and we do not endorse,
            verify, or take liability for any third-party offerings on
            Qflyers.
          </p>
          <p>
            All intellectual property (IP) rights related to the Qflyers
            platform, brand name, logo, and proprietary technology
            (collectively referred to as “Qflyers IP”) belong solely to
            Qflyers or our licensors. By using Qflyers, you acknowledge that
            you do not acquire any ownership rights over Qflyers IP. You are
            not permitted to use our name, logo, or branding for any
            purpose—including implying an affiliation, partnership, or
            endorsement from Qflyers—without our explicit written consent.
          </p>
          <p>
            As a user, we provide you with a limited, revocable,
            non-exclusive, and non-transferable right to use the platform to
            create, display, upload, and interact with content, but only in
            compliance with these Terms. If we offer you access to certain
            visual assets, such as images, icons, themes, fonts, videos, or
            graphics, you may only use them within your Qflyers profile and in
            accordance with any guidelines we provide. These materials are
            meant to enhance your profile’s design and should not be
            reproduced, shared, or used outside of Qflyers without permission.
          </p>
          <p>
            Furthermore, you must not alter, remove, or obscure any
            trademarks, copyrights, or proprietary notices found on the
            platform. Any attempts to copy, reproduce, distribute, modify,
            sell, license, translate, disassemble, decompile, decrypt,
            reverse-engineer, or derive the source code of Qflyers or any part
            of it are strictly prohibited.
          </p>
          <p>
            If you visit Qflyers profiles as a profile visitor, we grant you a
            limited, non-exclusive, and non-transferable right to view and
            interact with user-generated content through their profiles.
            However, any opinions, statements, products, services, or offers
            posted by users do not represent Qflyers’ views or endorsements.
            To the fullest extent permitted by law, we are not liable for any
            claims, damages, or disputes arising from content or transactions
            between users on the platform.
          </p>
          <p>
            By using Qflyers, you agree to respect the integrity of our
            platform and comply with these guidelines to ensure a safe,
            creative, and legally compliant experience for everyone
          </p>
          <h2>10. Fees and Payment</h2>
          <p>
            If you have chosen a paid plan on Qflyers, it is your
            responsibility to ensure timely payment of your subscription fees.
            These fees are generally charged in USD and may include
            transactional taxes like GST/VAT, unless stated otherwise.
            Subscription fees are billed in advance on a recurring basis,
            depending on whether you have selected a monthly or annual billing
            cycle. Your subscription will automatically renew at the end of
            each billing cycle under the most recent Terms unless you decide
            to cancel before renewal.
          </p>
          <p>
            When signing up for a paid plan, you must provide accurate billing
            details and a valid payment method (such as a credit card). By
            subscribing, you authorize Qflyers to charge the applicable fees
            through the chosen payment method. If an automatic payment fails,
            you will receive an online invoice that must be settled within the
            specified timeframe to avoid any disruptions in service.
          </p>
          <p>
            In addition to subscription fees, transaction fees may apply to
            certain transactions made through your Qflyers profile, including
            commissionable sales, product purchases, or Linker Monetization
            features. These fees may be percentage-based or calculated through
            another method, which will be clearly communicated to you.
            Transaction fees vary based on your chosen plan and are detailed
            on our pricing page. If applicable, transaction fees will be
            deducted from the transaction amount before it is credited to you.
            You are also responsible for any external fees, local taxes
            (including withholding taxes), and income taxes linked to payments
            received through Qflyers.
          </p>
          <p>
            Payments made through Qflyers are processed by external payment
            services like PayPal, Stripe, and Square, which impose processing
            fees. Each payment processor has its own fee structure, terms, and
            conditions, and it is your responsibility to review and comply
            with their policies. These processing fees are deducted from the
            transaction proceeds before you receive your payment. Since these
            fees are determined by third-party payment processors, Qflyers is
            not responsible for any additional charges or changes to their
            terms.
          </p>
          <h2>11. Tax requirements </h2>
          <p>
            When you choose to monetize your Qflyers by promoting products or
            services, you are solely responsible for complying with applicable
            tax laws in your country or region. This includes ensuring that
            you meet all legal and financial obligations related to sales tax,
            income tax, value-added tax (VAT), or any other relevant tax
            requirements imposed by local authorities.
          </p>
          <p>
            {" "}
            It is your duty to determine, report, and pay any taxes owed on
            transactions conducted through Qflyers. This may include
            collecting sales tax from customers, filing tax returns, and
            maintaining proper records as required by law. If you are
            uncertain about your tax obligations, you should seek professional
            tax advice to ensure compliance.
          </p>
          <p>
            Qflyers does not assume responsibility for any tax-related matters
            and is not liable for losses, penalties, or legal consequences
            resulting from your failure to meet tax obligations. It is
            important that you stay informed about changing tax regulations in
            your country to avoid any legal or financial issues.
          </p>
          <p>
            By using Qflyers to monetize your content, you acknowledge that
            you are fully responsible for managing your tax obligations and
            that Qflyers has no legal duty or liability in this regard.
          </p>
          <h2>12. Privacy</h2>
          <p>
            At Qflyers, safeguarding your privacy and that of your Profile
            Visitors is our priority. Our Privacy Notice outlines how we
            handle your personal data for our internal purposes. Additionally,
            our Data Processing Addendum (DPA), which can be found in our
            Trust Center and is included in these Terms, defines your
            obligations (and ours) regarding the privacy rights of visitors to
            your profile. By creating your account, you confirm that if the
            DPA applies to you, you’ve read, understood, and consented to it.
            To learn about our cookie usage, refer to our Cookie Notice.{" "}
          </p>
          <p>
            Additionally, we have a Data Processing Addendum (DPA), available
            in our Trust Center, which forms part of these Terms and
            Conditions. This document details both your obligations and ours
            when it comes to safeguarding the privacy rights of visitors to
            your profile. By creating an account and using Qflyers, you
            confirm that if the DPA applies to you, you have read, understood,
            and agreed to its terms. We also provide a Cookie Notice,
            explaining how we use cookies and tracking technologies to improve
            user experience on our Platform.
          </p>
          <p>
            Any data generated from your use of Qflyers—including interactions
            from Profile Visitors, transactions, content engagement, or
            platform activities—will be owned by Qflyers. This includes
            intellectual property rights associated with such data. As part of
            our service offerings, we may provide Data Analytics, which
            include insights and visual representations of data related to
            your profile and its activity. While we strive for accuracy, we
            cannot guarantee the absolute completeness of these analytics.
            However, we make every effort to ensure they are as reliable as
            possible to help you understand your audience and optimize your
            content.
          </p>
          <p>
            By using Qflyers, you acknowledge and agree to our privacy
            policies, the ownership of platform-generated data, and the terms
            outlined in the DPA and Privacy Notice. If you have any concerns
            about your data privacy, we encourage you to review our Trust
            Center and reach out to us for further clarification.
          </p>
          <h2>13. Confidentiality</h2>
          <p>
            At Qflyers, we may occasionally share confidential information
            with you, particularly if you participate in beta testing or other
            exclusive programs. This confidential information may include new
            and upcoming features, platform improvements, proprietary
            processes, or strategic insights that have not yet been publicly
            released.
          </p>
          <p>
            If we provide you with any confidential information about Qflyers
            or the Platform, you are required to keep it private, secure, and
            protected. You must not share, distribute, or disclose it to any
            third parties without our prior written consent. Additionally, you
            are expected to take reasonable precautions to prevent
            unauthorized access, including using secure storage methods and
            avoiding public discussions of confidential details
          </p>
          <p>
            If you participate in a Beta trial, we may allow you to share
            specific information publicly as part of your testing and feedback
            process. However, we will explicitly inform you about what can be
            shared. Unless we provide express permission, all beta-related
            details must remain confidential.
          </p>
          <p>
            By engaging with Qflyers and accessing any confidential
            information, you agree to respect our confidentiality terms and
            maintain the integrity of any privileged information we provide.
          </p>
          <h2>14. Recommended Content</h2>
          <p>
            At Qflyers, we strive to enhance your experience by recommending
            content, products, or services that may be relevant to you or your
            audience. These recommendations are based on a combination of data
            you provide, your activity on the Platform, and insights derived
            from other users' interactions. Our goal is to help you discover
            new and engaging content that aligns with your interests and
            enhances your experience on Qflyers.
          </p>
          <p>
            However, it is important to note that these recommendations do not
            constitute an endorsement by Qflyers. We do not guarantee the
            quality, accuracy, legality, or reliability of any recommended
            content, nor do we take responsibility for any interactions or
            transactions that may result from engaging with these suggestions.
          </p>
          <p>
            As a user, you should exercise your own discretion when engaging
            with recommended content, whether it’s a product, service, or
            another user’s profile. If you come across any content that
            appears misleading, inappropriate, or violates our Community
            Standards, we encourage you to report it so we can take
            appropriate action.
          </p>
          <p>
            By using Qflyers, you acknowledge that recommendations are
            generated algorithmically and may not always align with your
            preferences. You also understand that Qflyers is not liable for
            any outcomes resulting from engaging with recommended content.
          </p>
          <h2>15. Liability</h2>
          <p>
            Qflyers wants to make it clear that how you use the Platform is
            entirely your responsibility. While we provide tools and features
            to help you create and share content, we are not liable for any
            issues that arise from your use of the Platform. This includes any
            damages or losses resulting from actions such as downloading,
            installing, or utilizing the Platform, as well as copying,
            distributing, or downloading content from it. To safeguard your
            work, we strongly recommend that you maintain backups of your
            content and take precautions to protect your data, devices, and
            accounts while using Qflyers.
          </p>
          <p>
            By agreeing to these Terms, you also agree to protect Qflyers from
            any legal or financial losses that may occur if you violate these
            Terms or if a third party raises a claim against us due to your
            content or actions. If any such claims arise, you are responsible
            for covering any costs or damages associated with them.
          </p>
          <p>
            Additionally, neither you nor Qflyers will be held liable for any
            indirect, punitive, special, incidental, or consequential damages.
            This means that if you experience losses in business, revenue,
            profits, privacy, data, goodwill, or any other economic benefits,
            Qflyers will not be responsible for compensating you. This applies
            regardless of whether the damages arise due to a contract breach,
            negligence, or any other cause, even if we were aware of the
            possibility of such damages occurring.
          </p>
          <p>
            Our maximum liability to you under these Terms or in connection
            with your use of the Platform is limited to the greater of:
          </p>
          <ul>
            <li>
              1. The total fees you have paid us within the 12 months prior to
              the issue arising, or
            </li>
            <li>2. $100 USD</li>
          </ul>
          <p>
            By using Qflyers, you acknowledge and accept these liability
            limitations.
          </p>
          <h2>16. Disclaimers</h2>
          <p>
            Qflyers wants to make it clear that you use the Platform and its
            content at your own risk. The Platform is provided “AS IS” and “AS
            AVAILABLE”, meaning we do not guarantee that it will always
            function perfectly or meet your expectations. We, along with our
            affiliates and licensors, do not make any express or implied
            warranties or guarantees, including but not limited to:
          </p>

          <li>
            Continuous operation: We do not promise that the Platform will
            always be available, uninterrupted, or secure
          </li>
          <li>
            {" "}
            Error-free experience: We cannot guarantee that any errors or
            defects will be corrected.{" "}
          </li>
          <li>
            Virus-free environment: We do not warrant that the Platform is
            free of viruses or harmful components
          </li>
          <li>
            Effectiveness and results: We do not assure that using the
            Platform will meet your expectations or specific needs.
          </li>
          <li>
            Content accuracy: We do not verify the accuracy, reliability, or
            suitability of user-generated content or any other content on the
            Platform.
          </li>
          <p>
            These Terms are enforced to the maximum extent permitted by law.
            Nothing in these Terms is meant to exclude, restrict, or modify
            any legal rights you may have that cannot be excluded by contract.
          </p>
          <h2>17. Third Party Services </h2>
          <p>
            Qflyers partners with various third-party products and services to
            enhance user experience on the platform, such as payment
            processing and online store integrations. However, unless
            explicitly stated, Qflyers does not endorse or provide warranties
            for these third-party services and does not offer refunds for
            payments made to them. Users are responsible for reviewing,
            accepting, and complying with any separate terms and conditions
            that may apply to these services. Failure to adhere to these terms
            could result in the suspension, cancellation, or limitation of the
            user's account or access to certain features on the platform. Any
            required third-party terms will be displayed at the bottom of the
            Qflyers website, and the company's Privacy Notice includes a list
            of subprocessors it works with. By using Qflyers and any
            third-party services integrated within the platform, users
            acknowledge and accept these terms and the associated risks.
          </p>

          <h2>18. App Terms</h2>
          <p>
            To use the Qflyers app, users must download and install the
            software on their mobile or tablet devices. The app may be updated
            automatically, and any updates will be governed by these Terms.
            Users are granted a limited, revocable, non-exclusive, and
            non-transferable right to install and use the app on a single
            device they own or control. It is prohibited to distribute the app
            or make it available on a network where multiple devices can
            access it simultaneously. If an account is canceled by either the
            user or Qflyers, the app must be deleted from the user's device.
            When downloading the app from Apple’s App Store or Google Play,
            users acknowledge that these Terms are solely between them and
            Qflyers, not the App Store. If there is any inconsistency between
            these Terms and the App Store’s terms, the App Store's terms will
            take precedence. Qflyers is responsible for the app, including its
            content, maintenance, support, warranties (unless disclaimed), and
            any product or third-party claims regarding intellectual property
            infringement. If users have concerns about the app or become aware
            of any third-party claims, they should contact Qflyers at
            support@linktr.ee instead of the App Store. Additionally, users
            confirm they are not on any U.S. government restricted parties
            list and do not reside in a country subject to a U.S. embargo or
            designated as a “terrorist-supporting” nation. Furthermore, the
            App Store and its subsidiaries are considered third-party
            beneficiaries of these Terms and have the right to enforce them
            against users if necessary.
          </p>

          <h2>19. Open Source</h2>
          <p>
            The Qflyers app contains open-source software components, some of
            which are governed by their own specific license terms. These
            terms are available in the Open-Source Content library, located in
            the ‘Legal’ section of the app. If any open-source component has
            license terms that differ from the ones outlined in these Terms,
            then those specific license terms will take precedence over
            Qflyers' Terms. This means that users’ rights and responsibilities
            for such components will be determined by their respective
            licenses, rather than by Qflyers' general Terms of Service.
          </p>
          <h2>20. A few last things</h2>
          <p>
            Before using Qflyers, there are a few final points to consider.
            Depending on your location, certain laws may override parts of
            these Terms, in which case the applicable laws will take
            precedence. These Terms, along with the Privacy Notice and other
            linked policies, represent the complete agreement between you and
            Qflyers, and no additional terms will be added unless required by
            law. Any implied terms are excluded, except those that cannot
            legally be waived. If any section of these Terms is found to be
            invalid in a specific country, it will be removed for that region
            while the rest of the Terms remain in effect. These Terms are
            governed by the laws of Victoria and the Commonwealth of
            Australia, and any disputes will be handled in the courts of those
            jurisdictions. If Qflyers does not enforce a specific part of the
            Terms, it does not mean a waiver of any rights. Additionally,
            using Qflyers' Music Link or Video Link features to display
            YouTube videos means that you agree to abide by YouTube’s Terms of
            Service.
          </p>
        </div>
      </div>
    </div>
    <Footer />
  </div>
  )
}

export default CancelationandRefund
